import { Component, OnInit, Input } from '@angular/core';
import { TutorialInputModel } from 'src/app/core/model/input/tutorial-input-model';
import { TutorialService } from 'src/app/data/repository/tutorial-repository/tutorial.service';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
})
export class TutorialComponent implements OnInit {
  @Input() input: TutorialInputModel;

  constructor(private tutorialService: TutorialService) {}

  ngOnInit() {
    const box = document.getElementById('tutorial-box');
    this.animateOut(box);
    const text = document.getElementById('tutorial-text');
    this.prepareText(text);
  }

  dismiss() {
    this.tutorialService.dismiss();
  }

  animateIn(box: HTMLElement) {
    box.style.right = (this.input.boxDimentions.right + 2).toString() + 'px';
    box.style.top = (this.input.boxDimentions.top + 2).toString() + 'px';
    box.style.width = (this.input.boxDimentions.width - 4).toString() + 'px';
    box.style.height = (this.input.boxDimentions.height - 4).toString() + 'px';
    setTimeout(() => {
      this.animateOut(box);
    }, 300);
  }

  animateOut(box: HTMLElement) {
    box.style.right = this.input.boxDimentions.right.toString() + 'px';
    box.style.top = this.input.boxDimentions.top.toString() + 'px';
    box.style.width = this.input.boxDimentions.width.toString() + 'px';
    box.style.height = this.input.boxDimentions.height.toString() + 'px';
    setTimeout(() => {
      this.animateIn(box);
    }, 300);
  }

  prepareText(text: HTMLElement) {
    text.style.right = this.input.textDimentions.right.toString() + 'px';
    text.style.top = this.input.textDimentions.top.toString() + 'px';
    text.style.width = this.input.textDimentions.width.toString() + 'px';
    text.style.height = this.input.textDimentions.height.toString() + 'px';
    text.innerHTML = this.input.text;
  }
}
